import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import {Trans} from 'react-i18next';
import {Field, Form, Formik} from 'formik';
import _get from 'lodash/get';
import ToggleEnableField from '../../components/togglernablefield';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import Header from '../../components/header';
import ButtonWithRestoreGroup from '../../../../components/formik/ButtonWithRestoreGroup';
import {
  arrayMapping,
  faceAssessmentCategory,
  getBrandId,
  getTemplate,
  getTemplateDefaultConfig,
  mappingDisable,
  updateTemplate,
} from '../../../../utils/skincareUtils';
import Loader from '../../../../components/spinner/Loader';
import utils from '../../../../utils/smbUtils';
import smbUtils from '../../../../utils/smbUtils';
import {multipleSubscriptionsUtils} from '../../../../utils/solutionUtils';
import useWindowWidth from '../../../../components/hook/useWindowWidth';
import PublishToOnlineModal from '../components/PublishToOnlineModal';
import {history} from '../../../../utils/redux/store';
import {privilegeUtils} from '../../../../utils/privilegeUtils';
import CustomSwitch from '../../../../components/layout/CustomSwitch';
import SkincareFaceAssessmentPreview from './preview';
import ConfigurationModal from '../components/ConfigurationModal';
import {isFunctionBusyError} from '../../../../utils/errorUtils';

export default function FaceAssessment() {
  const [initValue, setInitValue] = useState({});
  const width = useWindowWidth();
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {
    AESTHETIC_SIMULATION: {isPremiumPlan, isEnterprisePlan, attrs},
  } = multipleSubscriptionsUtils.getSolutionInfos(auth);
  const {token, customerId} = utils.customerInfo(auth);
  const [revisionId, setRevisionId] = useState();
  const formRef = useRef();
  const [commonData, setCommonData] = useState({});
  const [templateId, setTemplateId] = useState('');
  const [publishStatus, setPublishStatus] = useState(false);
  const [isShowPublishModal, setIsShowPublishModal] = useState(false);
  const [modalState, setModalState] = useState({
    isShow: false,
    type: null,
    showFooter: false,
  });
  const [isLoaded, setIsLoaded] = useState(true);
  const rightLayoutRef = useRef(null);
  const [layoutWidth, setLayoutWidth] = useState(0);

  const handleRestore = mode => {
    getTemplateDefaultConfig('SmbFaceAssessment', mode, 2, customerId).then(
      r => {
        if (r && r.templateMetadata) {
          let data = r.templateMetadata;
          setInitValue({
            ...data,
          });

          updateTemplate(
            token,
            customerId,
            templateId,
            'FaceAssessment',
            data
          ).then(r => {
            setPublishStatus(!publishStatus);
            toast.success(
              <Trans i18nKey="c.f.simple.button.group.success">success</Trans>
            );
          });
        }
      }
    );
  };

  useEffect(() => {
    if (smbUtils.isCnSite(auth)) {
      history.push('/skincare-pro/ui-configuration/overview');
    }
    getBrandId(token, customerId).then(res => {
      if (res && _get(res, 'faceAssessmentRvId', '')) {
        setRevisionId(_get(res, 'faceAssessmentRvId', ''));
      }
      if (res && _get(res, 'commonSettingRvId')) {
        getTemplate(
          token,
          customerId,
          _get(res, 'commonSettingRvId'),
          'CommonSetting'
        ).then(res => {
          if (res && res.configJson) {
            setCommonData(JSON.parse(res.configJson));
          }
        });
      }
    });
  }, []);

  useLayoutEffect(() => {
    if (rightLayoutRef.current) {
      setLayoutWidth(rightLayoutRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (rightLayoutRef.current) {
        setLayoutWidth(rightLayoutRef.current.offsetWidth);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isLoaded]);

  const refreshData = () => {
    getTemplate(token, customerId, revisionId)
      .then(res => {
        if (res && res.metaDataJson) {
          setInitValue(JSON.parse(_get(res, 'metaDataJson', '')));
        }
        setTemplateId(_get(res, 'templateId', ''));
      })
      .then(() => setIsLoaded(false));
  };

  useEffect(() => {
    if (revisionId) {
      refreshData();
    }
  }, [revisionId]);

  const getInitValue = values => {
    return {
      enable: _get(values, 'enable', true),
      category: mappingDisable(
        _get(values, 'category', []),
        faceAssessmentCategory
      ),
    };
  };

  const formikConfig = {
    enableReinitialize: true,
    initialValues: getInitValue(initValue),
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true);
      const data = {
        ...values,
        category: arrayMapping(values.category),
      };
      await updateTemplate(
        token,
        customerId,
        templateId,
        'FaceAssessment',
        data
      )
        .then(r => {
          setInitValue({
            ...data,
          });
          setIsShowPublishModal(true);
        })
        .catch(e => {
          if (isFunctionBusyError(e)) {
            setModalState({
              isShow: true,
              type: 'processingInProgress',
              showFooter: false,
            });
            setSubmitting(false);
            return;
          }

          toast.error(
            <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
          );
          setSubmitting(false);
        });
    },
  };

  if (
    !(
      privilegeUtils.canUiConfig(auth) ||
      privilegeUtils.isTechnicalSupport(auth)
    )
  ) {
    history.push('/');
  }

  return isLoaded ? (
    <div>
      <Header />
      <Loader />
    </div>
  ) : (
    <Formik {...formikConfig} ref={formRef}>
      {formikProps => (
        <Form className="skincare-configuration-form">
          <Header publishStatus={publishStatus} dirty={formikProps.dirty} />
          <div className="skincare-configuration-layout">
            <div
              className="skincare-configuration-layout__left"
              style={{width: width < 1366 && width > 768 && '55%'}}
            >
              <div className="kt-portlet skincare-configuration-layout__left-portlet">
                <div className="kt-portlet__body skincare-configuration-layout__left-portlet__body">
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.face.assessment">
                      Face Assessment
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.face.assessment.enable">
                        Enable Face Assessment
                      </Trans>
                    </label>
                    <div className="col-9 col-lg-8 col-md-8 m-auto">
                      <Field
                        name="enable"
                        value={_get(formikProps.values, 'enable')}
                        component={CustomSwitch}
                      />
                    </div>
                  </div>
                  <div
                    className="kt-padding-t-15 kt-padding-b-15"
                    style={{fontSize: '1.25rem'}}
                  >
                    <Trans i18nKey="p.s.uiconfiguration.face.assessment.category">
                      Face Assessment Category
                    </Trans>
                  </div>
                  <div className="kt-margin-b-10 text-black-50">
                    <Trans i18nKey="p.s.uiconfiguration.face.assessment.category.desc">
                      Enable or disable the face assessment categories and set
                      the orders.
                    </Trans>
                  </div>
                  <Field name="category">
                    {props => (
                      <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
                        <div className="col-md-12">
                          <ToggleEnableField
                            itemList={_get(formikProps, 'values.category')}
                            onChange={list => {
                              props.form.setFieldValue(props.field.name, list);
                            }}
                            minEnable={1}
                            isEnterprise={isEnterprisePlan}
                            type={'AESTHETIC_SIMULATION'}
                          />
                        </div>
                      </div>
                    )}
                  </Field>
                </div>

                <div className="d-flex justify-content-end kt-margin-t-20">
                  <ButtonWithRestoreGroup
                    saveDirty={formikProps.dirty}
                    discardButton={false}
                    isUpdating={true}
                    onRestoreClick={() => {
                      handleRestore(isPremiumPlan ? 'Premium' : 'Essential');
                      formikProps.resetForm();
                    }}
                  />
                </div>
              </div>
            </div>
            {!isLoaded && (
              <div
                ref={rightLayoutRef}
                className="skincare-configuration-layout__right d-flex justify-content-center"
                style={{
                  width: width < 1366 && width > 768 && '45%',
                  transform: layoutWidth < 500 && `scale(${layoutWidth / 500})`,
                  overflow: layoutWidth < 500 && 'unset',
                  transformOrigin: layoutWidth < 500 && 'top center',
                }}
              >
                {formikProps.values && (
                  <SkincareFaceAssessmentPreview
                    commonData={commonData}
                    config={formikProps.values}
                    customerId={customerId}
                  />
                )}
              </div>
            )}
          </div>
          <PublishToOnlineModal
            isShow={isShowPublishModal}
            onPublish={isPublish => {
              formikProps.setSubmitting(false);
              setPublishStatus(isPublish);
              setIsShowPublishModal(false);
            }}
          />
          <ConfigurationModal
            modalState={modalState}
            onClose={() => setModalState({isShow: false, type: null})}
          />
        </Form>
      )}
    </Formik>
  );
}
